import { Injectable, inject } from '@angular/core';
import { User } from '@shared/models';
import { QueryOptions } from 'odata-query';
import { map, Observable, shareReplay } from 'rxjs';
import { Collection } from 'src/app/modules/admin/models';
import {
  GstarClient,
  UserResponseODataWithMetadataResponse,
} from 'src/app/web-api-client';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly gstarClient = inject(GstarClient);

  private cache$!: Observable<Collection<User>> | null;

  get(query?: Partial<QueryOptions<User>>): Observable<Collection<User>> {
    if (!this.cache$) {
      return this.getAllUser(query);
    }

    return this.cache$;
  }

  getAllUser(
    query?: Partial<QueryOptions<User>>
  ): Observable<Collection<User>> {
    this.cache$ = this.gstarClient
      .users2(
        undefined,
        'isActive eq true',
        query?.top?.toString(),
        query?.skip?.toString(),
        query?.orderBy?.toString(),
        query?.count?.toString(),
        undefined
      )
      .pipe(
        map((response: UserResponseODataWithMetadataResponse) => ({
          total: response.odataCount ?? 0,
          items:
            response.value?.map(userResponse => new User(userResponse)) ?? [],
        })),
        shareReplay(1)
      );

    return this.cache$;
  }

  getAdmins(query?: Partial<QueryOptions<User>>): Observable<Collection<User>> {
    return this.gstarClient
      .getusersbyrole(
        undefined,
        'isActive eq true',
        query?.top?.toString(),
        query?.skip?.toString(),
        query?.orderBy?.toString(),
        query?.count?.toString(),
        undefined
      )
      .pipe(
        map((response: UserResponseODataWithMetadataResponse) => ({
          total: response.odataCount ?? 0,
          items:
            response.value?.map(userResponse => new User(userResponse)) ?? [],
        })),
        shareReplay(1)
      );
  }
}
